var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hs-section-1"},[_vm._t("title",function(){return [(_vm.title)?_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"subtext"},[_vm._v(_vm._s(_vm.subtext))])]):_vm._e()]}),_c('div',{staticClass:"content"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }